import { createContext } from "react";

type PluginTemplatesTableContextValue = {
  takenPluginNames: string[];
};
export const PluginTemplatesTableContext = createContext<
  PluginTemplatesTableContextValue | undefined
>(undefined);
